var _rect, _rect2, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    rx: 11.8,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.325,
    y: 10.328,
    width: 58.342,
    height: 58.342,
    rx: 14.749,
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--gradient-stop)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.552 20.37h-35.86a4.896 4.896 0 0 0-4.89 4.89v22.82a4.895 4.895 0 0 0 4.89 4.89h2.252l2.81 5.619a1.629 1.629 0 0 0 2.266.686l11.035-6.305h17.497a4.896 4.896 0 0 0 4.89-4.89V25.26a4.895 4.895 0 0 0-4.89-4.89zm-3.26 16.3h-29.34a1.63 1.63 0 1 1 0-3.26h29.34a1.63 1.63 0 1 1 0 3.26zm0-6.52h-29.34a1.63 1.63 0 0 1 0-3.26h29.34a1.63 1.63 0 0 1 0 3.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4a6a538e85aaceab0675f2182f6ee475.svg";
export { ForwardRef as ReactComponent };